  $(document).ready(function(){
    $('.featured-brands .featured-brands_slider').slick({
        slidesToShow: 5,
        slidesToScroll: 2,
        arrows: true,
        dots: false,
        infinite: false,
        prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="arcs"><path d="M15 18l-6-6 6-6"></path></svg>',
        nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="arcs"><path d="M9 18l6-6-6-6"></path></svg>',
        responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 851,
      settings: {
        slidesToShow: 3
      }
    },
          {
      breakpoint: 501,
      settings: {
        slidesToShow: 2
      }
    }
  ]
    });

    // Model page: start the model carousel at the current model's tile
    var $current_model = $('.model-siblings .featured-brands_slide .is-current').closest('.slick-slide');
    if ($current_model.length) {
      $('.model-siblings .featured-brands_slider').slick('slickGoTo', parseInt($current_model.attr('data-slick-index'), 10) || 0, true);
    }

           $('.facets__form .facets__list input[type="checkbox"]').each(function(){
             if ($(this).prop('checked')==true){
                 var check_val = $(this).val();
                 $('.collection_models .featured-brands_slider div[data-value]').each(function(){
                    if($(this).data('value') == check_val){
                      $(this).toggleClass('active');
                    }
                 });
                }
      });


          $('.facets__form .facets__list input[type="checkbox"]').change(function(){
       if ($(this).prop('checked')==true){
           var check_val = $(this).val();
           $('.collection_models .featured-brands_slider div[data-value]').each(function(){
              if($(this).data('value') == check_val){
                $(this).addClass('active');
              }
           });
          }else{
                    var check_val = $(this).val();
           $('.collection_models .featured-brands_slider div[data-value]').each(function(){
              if($(this).data('value') == check_val){
                $(this).removeClass('active');
              }
           });
          }

            setTimeout(function() {
              $('.facets__form .facets__list input[type="checkbox"]').each(function(){
                 var check_val = $(this).val();
                  var filter_text = $.trim($(this).parent('label').text());
                 $('.collection_models .featured-brands_slider div[data-value]').each(function(){
                   if($(this).data('value') == check_val){
                     $(this).find('.filter_label').text(filter_text);
                    }
                 });
              });
               }, 1500);
    });


  // Only filter-type tiles (div with data-value) apply the filter; tiles rendered as <a class="model-link"> navigate to their sub-collection
  $('.collection_models .featured-brands_slide .title[data-value]').click(function(e){
    e.preventDefault();
    var current = this;
   var model_name = $(this).data('value');
    var id = $('.facets__form .facets__list input[value="'+ model_name +'"]').attr('id');
    $('.facets__form .facets__list label[for="' + id + '"]').click();
  });

  });
